import React, { ReactNode } from 'react';
import classNames from 'classnames';
import './section-heading.scss';

interface SectionHeadingProps {
  title: ReactNode;
  className?: string;
}

const SectionHeading = ({ title, className }: SectionHeadingProps) => {
  return (
    <div className={classNames('section-heading', className)}>{title}</div>
  );
};

export default SectionHeading;